import { h } from 'preact';
import ClubSelector from '../components/layout/ClubSelector.jsx';

export default function ClubSelectView() {
  return <ClubSelector />;
}
